import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';


const SocialMedia = () => {
    const [viewCount, setViewCount] = useState(0);
    const targetViews = 100000000;


    useEffect(() => {
        let start = 0;
        const duration = 2000;
        const increment = targetViews / (duration / 16);


        const timer = setInterval(() => {
            start += increment;
            if (start >= targetViews) {
                setViewCount(targetViews);
                clearInterval(timer);
            } else {
                setViewCount(Math.floor(start));
            }
        }, 16);


        return () => clearInterval(timer);
    }, [targetViews]);


    const formatViews = (num) => {
        if (num >= 1000000) {
            return (num / 1000000).toFixed(1) + 'M';
        }
        return num.toLocaleString();
    };


    return (
        <>
            {/* VIRAL VIDEO SHOWCASE SECTION */}
            <section className="py-32 bg-gradient-to-b from-white via-wedding-blush to-white relative overflow-hidden">
                <div className="container mx-auto px-4 max-w-6xl relative z-10">
                    {/* Header */}
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8 }}
                        className="text-center mb-16"
                    >
                        <motion.div
                            className="inline-flex items-center gap-2 bg-gradient-to-r from-pink-500 to-purple-600 text-white px-6 py-2 rounded-full mb-6 shadow-lg"
                            animate={{ scale: [1, 1.05, 1] }}
                            transition={{ duration: 2, repeat: Infinity }}
                        >
                            <span className="text-sm font-bold uppercase tracking-wider">VIRAL VIDEO</span>
                        </motion.div>


                        <h2 className="text-4xl md:text-6xl font-serif text-wedding-accent mb-4">
                            Our Viral Moment
                        </h2>
                        <div className="flex items-center justify-center gap-3 mb-6">
                            <div className="w-16 h-[1px] bg-wedding-primary"></div>
                            <div className="w-2 h-2 bg-wedding-primary rounded-full"></div>
                            <div className="w-16 h-[1px] bg-wedding-primary"></div>
                        </div>
                        <p className="text-wedding-charcoal/60 text-lg max-w-2xl mx-auto">
                            Our love story touched millions of hearts across the world
                        </p>
                    </motion.div>


                    {/* Video Container */}
                    <div className="max-w-4xl mx-auto">
                        <motion.div
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.8 }}
                            className="relative"
                        >
                            {/* Main Video Container */}
                            <div className="relative bg-white border-4 border-white shadow-2xl overflow-hidden">
                                {/* Instagram Embed */}
                                <div className="relative bg-black w-full overflow-hidden" style={{ paddingBottom: '125%' }}>
                                    <iframe
                                        src="https://www.instagram.com/reel/DQvmlqeko-B/embed"
                                        width="100%"
                                        height="100%"
                                        frameBorder="0"
                                        scrolling="no"
                                        allowFullScreen={true}
                                        title="Our Viral Wedding Video"
                                        className="absolute top-0 left-0 w-full h-full"
                                    ></iframe>
                                </div>
                            </div>


                            {/* Stats Bar */}
                            <motion.div
                                className="mt-8 bg-white border-2 border-wedding-primary/20 p-6 md:p-8"
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ delay: 0.3 }}
                            >
                                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
                                    {/* Views */}
                                    <div className="relative">
                                        <div className="text-4xl md:text-5xl font-bold text-wedding-accent mb-2">
                                            {formatViews(viewCount)}+
                                        </div>
                                        <p className="text-sm uppercase tracking-widest text-gray-600 font-medium">
                                            Views
                                        </p>
                                    </div>


                                    {/* Likes */}
                                    <div className="relative">
                                        <div className="flex items-center justify-center gap-2 mb-2">
                                            <span className="text-4xl md:text-5xl font-bold text-wedding-accent">4.3M</span>
                                        </div>
                                        <p className="text-sm uppercase tracking-widest text-gray-600 font-medium">
                                            Likes
                                        </p>
                                    </div>


                                    {/* Shares */}
                                    <div className="relative">
                                        <div className="flex items-center justify-center gap-2 mb-2">
                                            <span className="text-4xl md:text-5xl font-bold text-wedding-accent">254k</span>
                                        </div>
                                        <p className="text-sm uppercase tracking-widest text-gray-600 font-medium">
                                            Shares
                                        </p>
                                    </div>
                                </div>
                            </motion.div>


                            {/* Caption */}
                            <motion.div
                                className="mt-8 text-center"
                                initial={{ opacity: 0 }}
                                whileInView={{ opacity: 1 }}
                                viewport={{ once: true }}
                                transition={{ delay: 0.5 }}
                            >
                                <p className="text-lg md:text-xl text-wedding-accent italic font-serif mb-2">
                                    "A love story that captured hearts worldwide"
                                </p>
                                <p className="text-sm text-gray-600">
                                    Thank you for making us part of your feed ❤️
                                </p>
                            </motion.div>
                        </motion.div>
                    </div>
                </div>
            </section>


            {/* MEDIA COVERAGE SECTION - NEW */}
            <section className="py-24 bg-white relative overflow-hidden">
                <div className="container mx-auto px-4 max-w-6xl relative z-10">
                    {/* Header */}
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8 }}
                        className="text-center mb-16"
                    >
                        <motion.div
                            className="inline-flex items-center gap-2 bg-gradient-to-r from-red-600 to-orange-500 text-white px-6 py-2 rounded-full mb-6 shadow-lg"
                        >
                            <span className="text-2xl">📰</span>
                            <span className="text-sm font-bold uppercase tracking-wider">Featured In</span>
                        </motion.div>

                        <h2 className="text-3xl md:text-5xl font-serif text-wedding-accent mb-4">
                            Media Coverage
                        </h2>
                        <div className="flex items-center justify-center gap-3 mb-6">
                            <div className="w-16 h-[1px] bg-wedding-primary"></div>
                            <div className="w-2 h-2 bg-wedding-primary rounded-full"></div>
                            <div className="w-16 h-[1px] bg-wedding-primary"></div>
                        </div>
                        <p className="text-gray-600 text-lg">
                            Our viral moment caught national attention
                        </p>
                    </motion.div>

                    {/* MEDIA COVERAGE SECTION - WITH YOUR SCREENSHOT */}
                    <section className="py-24 bg-white relative overflow-hidden">
                        <div className="container mx-auto px-4 max-w-6xl relative z-10">

                            {/* ABP News Card */}
                            <motion.div
                                initial={{ opacity: 0, y: 40 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.8 }}
                                className="max-w-5xl mx-auto"
                            >
                                <a href="https://www.abplive.com/trending/groom-surprise-dance-for-his-bride-reaction-of-girl-is-going-viral-watch-video-here-3040760" target="_blank" rel="noopener noreferrer" className="group block">
                                    <div className="bg-white border-4 border-wedding-accent/20 shadow-2xl overflow-hidden hover:border-wedding-accent hover:shadow-3xl hover:-translate-y-2 transition-all duration-500 rounded-2xl">

                                        {/* PERFECT MOBILE SIZING */}
                                        <div className="bg-gradient-to-r from-red-600 to-red-700 p-6 sm:p-8 flex flex-col sm:flex-row items-center sm:items-center gap-4 sm:gap-6">
                                            <div className="flex items-center justify-center sm:justify-start gap-4 w-full sm:w-auto">
                                                {/* MOBILE PERFECT SCREENSHOT SIZES */}
                                                <img
                                                    src="/images/abp-news-screenshot.png"
                                                    alt="ABP News Coverage"
                                                    className="w-40 h-28 sm:w-48 sm:h-32 md:w-64 md:h-40 lg:w-80 lg:h-52 xl:w-96 xl:h-60 object-fill rounded-xl shadow-2xl border-4 border-white hover:shadow-3xl transition-all duration-300"
                                                />
                                            </div>

                                            <div className="text-center sm:text-left text-white flex-1 min-w-0 px-2 sm:px-0">
                                                <h3 className="text-xl sm:text-2xl md:text-3xl font-bold uppercase tracking-wide mb-1">
                                                    ABP News Hindi
                                                </h3>
                                                <p className="text-red-100 text-sm sm:text-base font-medium mb-0.5">TRENDING STORY</p>
                                                <p className="text-xs sm:text-sm text-red-200 font-medium">National Coverage</p>
                                            </div>

                                            <svg
                                                className="w-10 h-10 sm:w-12 sm:h-12 text-white group-hover:translate-x-2 transition-transform duration-300 flex-shrink-0"
                                                fill="none"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24"
                                            >
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                                            </svg>
                                        </div>


                                        {/* Content */}
                                        <div className="p-12 lg:p-16">
                                            <h4 className="text-3xl md:text-4xl lg:text-5xl font-serif text-wedding-accent mb-6 leading-tight group-hover:text-wedding-primary transition-all">
                                                "दूल्हे ने अपनी दुल्हन को दी सरप्राइज परफॉर्मेंस!"
                                            </h4>
                                            <p className="text-gray-700 text-xl md:text-2xl mb-8 leading-relaxed font-light">
                                                दुल्हन का रिएक्शन देख यूजर्स बोले, प्राइसलेस
                                            </p>
                                            <div className="bg-wedding-blush/50 border-l-8 border-wedding-accent p-8 rounded-r-lg mb-8">
                                                <blockquote className="text-2xl md:text-3xl font-serif italic text-wedding-charcoal">
                                                    "यही असली रोमांस है, जो दिखता नहीं, महसूस होता है"
                                                </blockquote>
                                                <p className="text-right mt-4 text-sm text-gray-600 font-medium">— ABP News Reader</p>
                                            </div>
                                            <div className="flex items-center justify-center gap-3 pt-6 border-t border-gray-200 text-wedding-accent font-semibold text-lg group-hover:gap-4">
                                                <span className="uppercase tracking-wider">Read Full Article</span>
                                                <svg className="w-6 h-6 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                                                </svg>
                                            </div>
                                        </div>
                                        {/* Footer */}
                                        <div className="bg-gray-50 px-8 py-6 border-t border-gray-200">
                                            <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-gray-600">
                                                <span>📅 Featured: November 2026</span>
                                                <div className="flex items-center gap-2">
                                                    <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></span>
                                                    <span>Live Article</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </motion.div>
                        </div>
                    </section>
                </div>
            </section>


            {/* FOLLOW US SECTION */}
            <section className="py-24 bg-gradient-to-b from-white to-wedding-blush relative overflow-hidden">
                <div className="container mx-auto px-4 max-w-4xl relative z-10">
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8 }}
                        className="text-center mb-12"
                    >
                        <h2 className="text-3xl md:text-5xl font-serif text-wedding-accent mb-4">
                            Join Our Journey
                        </h2>
                        <div className="flex items-center justify-center gap-3 mb-6">
                            <div className="w-16 h-[1px] bg-wedding-primary"></div>
                            <div className="w-2 h-2 bg-wedding-primary rounded-full"></div>
                            <div className="w-16 h-[1px] bg-wedding-primary"></div>
                        </div>
                        <p className="text-gray-600">
                            Follow us for more special moments and wedding updates
                        </p>
                    </motion.div>


                    {/* Social Links */}
                    <div className="flex flex-col sm:flex-row gap-4 justify-center">
                        <a
                            href="https://www.instagram.com/prafuloo7/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="px-10 py-4 bg-gradient-to-r from-purple-600 via-pink-500 to-orange-400 text-white text-sm uppercase tracking-widest font-medium text-center hover:opacity-90 transition-opacity"
                        >
                            Follow on Instagram
                        </a>


                        <a
                            href="https://www.youtube.com/@arrangedattached"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="px-10 py-4 bg-white border-2 border-wedding-accent text-wedding-accent text-sm uppercase tracking-widest font-medium text-center hover:bg-wedding-accent hover:text-white transition-colors"
                        >
                            Subscribe YouTube
                        </a>
                    </div>
                </div>
            </section>
        </>
    );
};


export default SocialMedia;
